import { ApiUtility } from "../Utilities/ApiUtility.axios";


export enum CompanyMemberBiometricStatus {
  Requested = 1,
  Completed = 2,
  Failed = 3,
  Rejected = 4,
}

export interface IBiometricListItem {
  clientId: string;
  memberName: string;
  businessName: string;
  status: CompanyMemberBiometricStatus;
  requestedOn: string | null;
  completedOn: string | null;
  dateOfBirth?: string | null;
  identityVerification?: string | null;
}

export interface IPagedBiometricResult<T> {
  totalRecords: number;
  totalCompletedCount?: number;
  items: T[];
}


class BiometricStatsService {
  route = `/API/BiometricStats`;

  getBiometricStats = (
    practiceId: number,
    start: number = 0,
    length: number = 15,
    search: string = "",
    fromDate?: string,
    toDate?: string,
    sortCol?: string,
    sortDir?: string
  ) => {
    return ApiUtility.get(`${this.route}`, {
      practiceId,
      start,
      length,
      search,
      fromDate,
      toDate,
      sortCol,
      sortDir,
    });
  };

  getBiometricList = (
    practiceId: number,
    status?: CompanyMemberBiometricStatus,
    start: number = 0,
    length: number = 15,
    search: string = "",
    fromDate?: string,
    toDate?: string,
    sortCol?: string,
    sortDir?: string
  ) => {
    return ApiUtility.get(`${this.route}/biometric-report`, {
      practiceId,
      status,
      start,
      length,
      search,
      fromDate,
      toDate,
      sortCol,
      sortDir,
    });
  };

  getBiometricStatsDownload = (
    practiceId: number,
    practiceName: string,
    search: string = "",
    fromDate?: string,
    toDate?: string,
    sortCol?: string,
    sortDir?: string
  ) => {
    return ApiUtility.downloadFile(`${this.route}`, {
      practiceId,
      practiceName,
      search,
      fromDate,
      toDate,
      sortCol,
      sortDir,
      isDownload: true,
    });
  };
}

export default new BiometricStatsService();